import React, { Component } from "react";
import {
  company,
  loading,
  float,
  NavbarWarehouse,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  UPLOAD,
  MAX_UPLOAD_SIZE,
  t,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";
import { compressImageFile } from "../../utils/fileUpload";
import { can } from "../../utils/permission";

export default class BranchesManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_status: "",

      modal_create: false,
      modal_update: false,
      count: 0,

      // Form States (Modal)
      uid: "",
      company_id: company?.id || "", // Default company_id
      name: "",
      company_name_th: "",
      company_name_en: "",
      logo: "",
      is_active: "Active",

      // List Data
      data: [],
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search } = this.state;
    let data, count;
    loading(true);

    // Call GET API Branches
    let result = await GET("warehouse/branches", {
        page_size: 10,
        page: page,
        data_search: filter_search || "",
        is_active: this.state.filter_status || "",
    });

    if (result?.status) {
      data = result.data;
      count = result.pagination?.count || 0;
    }

    this.setState({ data: data || [], count });
    loading(false);
  };

  // อัปโหลดโลโก้บริษัทของสาขา (ใช้ช่องทางเดียวกับรูปอื่นๆ ในระบบ -> S3 แล้วเก็บเป็น URL)
  UploadLogo = async (file) => {
    if (!file) return;

    if (!file.type?.startsWith("image/")) {
      alert("", "warning", t("warning"), t("company_logo_hint"));
      return;
    }
    if (file.size > MAX_UPLOAD_SIZE.image) {
      alert("", "warning", t("warning"), t("company_logo_hint"));
      return;
    }

    loading(true);
    // บีบอัดก่อนอัปเพื่อลดพื้นที่จัดเก็บ (บีบไม่ได้ -> ใช้ไฟล์ต้นฉบับ)
    const compressed = await compressImageFile(file);
    const res = await UPLOAD(compressed, { folder: "branches/logos" });
    if (res?.status === true && res?.data?.file_path) {
      this.setState({ logo: res.data.file_path });
    } else {
      alert("", "warning", t("warning"), res?.message || `${t("upload")} ${t("fail")}`);
    }
    loading(false);
  };

  CreateUpdate = async () => {
    const {
      uid,
      company_id,
      name,
      company_name_th,
      company_name_en,
      logo,
      is_active,
    } = this.state;

    // Validation
    if (!name.trim()) {
      alert("", "warning", t("warning"), t("verify_branch"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);

      // Request Body
      let body = {
        company_id,
        name,
        company_name_th: company_name_th || "",
        company_name_en: company_name_en || "",
        logo: logo || "-", // "-" = placeholder ของ removeEmptyString -> ส่งถึง backend เป็น "" เพื่อล้างโลโก้เดิม
        is_active: is_active === "Active",
      };

      // Call API
      let result = !uid
        ? await POST("warehouse/branches", body)
        : await PUT("warehouse/branches/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false }, () => {
            this.Get(1); // Refresh data
        });
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || t("error_occurred"),
        );
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("warehouse/branches/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.Get(1); // Refresh data after delete
      }
      loading(false);
    }
  };

  resetForm = () => {
    this.setState({
      uid: "",
      name: "",
      company_name_th: "",
      company_name_en: "",
      logo: "",
      is_active: "Active",
    });
  };

  render() {
    const {
      data,
      count,
      filter_search,
      filter_status,
      modal_create,
      modal_update,
      name,
      company_name_th,
      company_name_en,
      logo,
      is_active,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("branches_management")}</h3>
                        <div className="text-secondary text-14">{t("manage_branches_desc")}</div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className="d-flex gap-2 flex-wrap">
                            <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-300"
                                    style={{ height: "38px" }}
                                    placeholder={t("search_branches")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                                />
                            </div>
                            <select className="form-select wpx-150" value={filter_status} onChange={(e) => this.setState({ filter_status: e.target.value })}>
                                <option value="">{t("all_status")}</option>
                                <option value="true">{t("active")}</option>
                                <option value="false">{t("inactive")}</option>
                            </select>
                            <div className="d-flex gap-2">
                              <button
                                className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm"
                                onClick={() => this.Get(1)}
                              >
                                {t("filter")}
                              </button>
                              <button
                                className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                onClick={() => this.setState({ filter_search: "", filter_status: "" }, () => this.Get(1))}
                              >
                                {t("clear_all")}
                              </button>
                            </div>
                        </div>
                        {can("branch.create") && (
                        <button
                            className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                            onClick={() => {
                                this.resetForm();
                                this.setState({ modal_create: true, name: "", is_active: "Active" });
                            }}
                        >
                            <span className="me-2 text-16">+</span> {t("add_branches")}
                        </button>
                        )}
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
                    {/* Branches Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 border-0 wpx-250">{t("branch")}</th>
                                    <th className="py-3 border-0 wpx-250">{t("company_name")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("status")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, idx) => (
                                    <tr key={idx} className="border-bottom border-light bg-white">
                                        {/* Branch Info */}
                                        <td className="py-3">
                                            <div className="d-flex align-items-center">
                                                {item.logo ? (
                                                    <div className="wpx-35 hpx-35 rounded-circle me-3 flex-shrink-0 overflow-hidden border bg-white d-flex align-items-center justify-content-center">
                                                        <img src={item.logo} alt="logo" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                                    </div>
                                                ) : (
                                                    <div
                                                        className={`wpx-35 hpx-35 rounded-circle text-white d-flex align-items-center justify-content-center me-3 flex-shrink-0 fw-bold text-12 bg-primary`}
                                                    >
                                                        <span className="icon">{"\uf3c5"}</span>
                                                    </div>
                                                )}
                                                <div>
                                                    <div className="fw-bold text-dark text-14">{item.name}</div>
                                                </div>
                                            </div>
                                        </td>

                                        {/* \u0e0a\u0e37\u0e48\u0e2d\u0e1a\u0e23\u0e34\u0e29\u0e31\u0e17\u0e17\u0e35\u0e48\u0e08\u0e30\u0e02\u0e36\u0e49\u0e19\u0e2b\u0e31\u0e27\u0e40\u0e2d\u0e01\u0e2a\u0e32\u0e23 Service Report */}
                                        <td className="py-3">
                                            <div className="text-dark text-14">{item.company_name_th || "-"}</div>
                                            <div className="text-secondary text-12">{item.company_name_en || ""}</div>
                                        </td>

                                        {/* Status */}
                                        <td className="text-center">
                                            {item.is_active ? (
                                                <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                            ) : (
                                                <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                            )}
                                        </td>

                                        {/* Actions */}
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-2 justify-content-center">
                                                {can("branch.update") && (
                                                <ActionIconButton
                                                    label={t("edit")}
                                                    icon={ACTION_ICONS.edit}
                                                    variant="warning"
                                                    onClick={() => {
                                                        this.setState({
                                                            modal_update: true,
                                                            ...item,
                                                            is_active: item.is_active ? "Active" : "Inactive",
                                                        });
                                                    }}
                                                />
                                                )}
                                                {can("branch.delete") && (
                                                <ActionIconButton
                                                    label={t("delete")}
                                                    icon={ACTION_ICONS.delete}
                                                    variant="danger"
                                                    onClick={() => {
                                                        this.Delete(item.uid);
                                                    }}
                                                />
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} {data.length > 0 ? 1 : 0}-{data.length} {t("of")} {count} {t("categories_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                </div>
            </div>

            {/* MODAL: ADD/EDIT BRANCH */}
            <Modal
                size="md"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
            >
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("edit_branches") : t("add_new_branches")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    <div className="row g-4">
                        {/* Basic Information */}
                        <div className="col-12">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf05a"}</span> {t("basic_information")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("branches_basic_info_desc")}</small>
                            <div className="row g-3">
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("branch")} <span className="text-danger">*</span>
                                    </label>
                                    <input type="text" maxLength={200} className="form-control py-2" placeholder="e.g. BPSA, BPSB" value={name} onChange={(e) => this.setState({ name: e.target.value })} />
                                    <small className="text-muted d-block text-end mt-1">{(name || "").length}/200</small>
                                </div>

                                {/* ข้อมูลบริษัทของสาขา - ใช้เป็นหัวเอกสาร Service Report */}
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">{t("company_name_th")}</label>
                                    <input
                                        type="text"
                                        maxLength={200}
                                        className="form-control py-2"
                                        placeholder="e.g. บริษัท บีพีเอส กรุงเทพ จำกัด"
                                        value={company_name_th || ""}
                                        onChange={(e) => this.setState({ company_name_th: e.target.value })}
                                    />
                                </div>
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">{t("company_name_en")}</label>
                                    <input
                                        type="text"
                                        maxLength={200}
                                        className="form-control py-2"
                                        placeholder="e.g. BPS Bangkok Co., Ltd."
                                        value={company_name_en || ""}
                                        onChange={(e) => this.setState({ company_name_en: e.target.value })}
                                    />
                                </div>
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">{t("company_logo")}</label>
                                    <div className="d-flex align-items-center gap-3">
                                        <div
                                            className="border rounded-3 d-flex align-items-center justify-content-center flex-shrink-0 bg-light overflow-hidden"
                                            style={{ width: "80px", height: "80px" }}
                                        >
                                            {logo ? (
                                                <img src={logo} alt="logo" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                                            ) : (
                                                <span className="icon text-secondary text-20">{"\uf03e"}</span>
                                            )}
                                        </div>
                                        <div>
                                            <div className="d-flex gap-2">
                                                <label className="btn btn-white border px-3 py-1 rounded-3 fw-bold text-14 mb-0 pointer">
                                                    <span className="icon me-2">{"\uf093"}</span> {t("upload")}
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        hidden
                                                        onChange={(e) => {
                                                            const file = e.target.files?.[0];
                                                            e.target.value = "";
                                                            this.UploadLogo(file);
                                                        }}
                                                    />
                                                </label>
                                                {logo ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-white border text-danger px-3 py-1 rounded-3 fw-bold text-14"
                                                        onClick={() => this.setState({ logo: "" })}
                                                    >
                                                        {t("remove")}
                                                    </button>
                                                ) : null}
                                            </div>
                                            <small className="text-muted d-block mt-2">{t("company_logo_hint")}</small>
                                            <small className="text-muted d-block">{t("branch_company_info_desc")}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Status */}
                        <div className="col-12 mt-2 border-top pt-4">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf772"}</span> {t("status")}
                            </h6>
                            <div className="d-flex gap-4 mt-3">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="branchStatus"
                                        id="statusActive"
                                        checked={is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="branchStatus"
                                        id="statusInactive"
                                        checked={is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
                    {(this.state.modal_update ? can("branch.update") : can("branch.create")) && (
                    <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                        onClick={() => {
                            this.CreateUpdate();
                        }}
                    >
                        <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
